import { getGrantedSubAccounts } from './API';
/**
 * Fetches the user's sub-account names and associated roles, grouped by associated group 
 */
const GetGrantedSubAccounts = async (accessToken) => {
  try {
    const response = await getGrantedSubAccounts(accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error getting granted sub-accounts: ', error.message);
    return { success: false, data: 'Error: API server is down or sub-account does not exist' };
  }
};

export default GetGrantedSubAccounts;
